module.exports = __webpack_public_path__ + "static/media/click-number-wrong.820dd3f0.mp3";